module.exports = __webpack_public_path__ + "img/Filter.d901751c.svg";